// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2287": "22be4199","3192": "30697fcd","7869": "22f405b2",}[chunkId] + ".css"
}